<ag-grid-angular
  class="ag-theme-alpine"
  [pagination]="true"
  [serverSideInfiniteScroll]="true"
  [rowClassRules]="rowClassRules"
  [paginationPageSize]="paginationPageSize"
  [cacheBlockSize]="cacheBlockSize"
  [maxBlocksInCache]="maxBlocksInCache"
  [maxConcurrentDatasourceRequests]="maxConcurrentDatasourceRequests"
  [rowSelection]="rowSelection"
  [rowModelType]="rowModelType"
  [defaultColDef]="defaultColDef"
  [columnDefs]="columnDefs"
  [sideBar]="sideBar"
  [suppressCopyRowsToClipboard]="true"
  [getContextMenuItems]="getContextMenuItems"
  [rowGroupPanelShow]="rowGroupPanelShow"
  [rowData]="rowData$ | async"
  [animateRows]="true"
  (gridReady)="onGridReady($event)"
  (selectionChanged)="onSelectionChanged($event)"
  (filterChanged)="filterChanged($event)"
  (columnMoved)="columnEverythingChanged($event)"
  (columnResized)="columnEverythingChanged($event)"
  (columnPinned)="columnEverythingChanged($event)"
  (columnVisible)="columnEverythingChanged($event)"
></ag-grid-angular>
<!--[rowGroupPanelShow]="'always'"-->
